import { useMemo } from 'react';
import { useToast } from '@chakra-ui/react';

const defaultOptions = {
  position: 'top-right',
  status: 'error',
  isClosable: true,
  variant: 'subtle',
};

function useCustomToast(options) {
  const finalOptions = useMemo(
    () => (options ? ({ ...defaultOptions, ...options }) : defaultOptions),
    [options],
  );
  const toast = useToast(finalOptions);

  return toast;
}

export default useCustomToast;
